export const BASE_URL = 'https://' + window.location.hostname + '/api';
export const API_URL = {
  CONDITION_AND_POLICY: 'https://www.mindweal.com/wp-json/wp/v2/pages',
  // Authentication api endpoints
  SIGN_UP: `${BASE_URL}/auth/1.0/signup`,
  MIGRATE: `${BASE_URL}/auth/1.0/migration/signup`,
  TRANSFER: `${BASE_URL}/auth/1.0/transfer/signup`,
  ACCOUNT_CONFIRMATION: `${BASE_URL}/auth/1.0/activate-account`,
  RESEND_EMAIL_VERIFICATION_LINK: `${BASE_URL}/auth/1.0/resend-verification`,
  SEND_RESET_PASSWORD_EMAIL: `${BASE_URL}/auth/1.0/send-reset-password-link`,
  GET_EMAIL_API: `${BASE_URL}/auth/1.0/user-email`,
  RESET_PASSWORD: `${BASE_URL}/auth/1.0/reset-password`,
  SEND_QUERY: '/auth/1.0/registration-query',
  VALIDATE_TOKEN: '/auth/1.0/validate-token',
  SIGN_IN: '/auth/1.0/signin',
  VALIDATE_CAPTCHA: '/auth/1.0/verify',
  REFRESH_TOKEN: '/auth/1.0/refreshtoken',

  // ehr-service api endpoints
  SCHEDULE_APPOINTMENT: `${BASE_URL}/ehr-service/appointmentRequest`,
  APPOINTMENT_CONFIRMATION_DETAILS: `${BASE_URL}/ehr-service/appointment`,
  APPOINTMENT_HISROTY: `${BASE_URL}/ehr-service/appointment/historyDetails`,
  PAYMENT_STATUS: `${BASE_URL}/ehr-service/payment/status`,
  UPCOMING_APPOINTMENT_DETAILS: `${BASE_URL}/ehr-service/appointment`,
  POST_MEETING_DETAILS: `${BASE_URL}/ehr-service/meeting/1.0`,
  MCAT_I_SCORE_APPOINTMENT_DETAILS: `${BASE_URL}/ehr-service/appointment/list/`,
  POST_MEETING_SUMMARY: `${BASE_URL}/ehr-service/appointment/summery`,

  // Documentation api endpoints
  DOCUMENT_LIST: `${BASE_URL}/documentation-mgmt/document/list`,
  DOWNLOAD_DOCUMENT: `${BASE_URL}/documentation-mgmt/consent/download`,
  SEND_DOCUMENT_REMINDER: `${BASE_URL}/documentation-mgmt/document/sendReminder`,

  // Patient management api endpoints
  DR_CHRONO_JOB_HISTORY: `${BASE_URL}/patient-mgmt/patient/1.0/history`,
  PATIENTS_LIST: `${BASE_URL}/patient-mgmt/patientDetails/1.0/admin/patients`,
  APPOINTMENT_LIST: `${BASE_URL}/patient-mgmt/patientDetails/1.0/admin/appointments`,
  PATIENT_EHR_DETAILS: `${BASE_URL}/patient-mgmt/patientDetails/1.0/admin`,
  PATIENT_SNAPSHOT_DETAILS: `${BASE_URL}/patient-mgmt/patientDetails/1.0`,

  // Profile api endpoints
  GET_PATIENT: '/patient-mgmt/patient/1.0',
  PATIENT_INFORMATION: '/patient-mgmt/patient/1.0',
  GUARDIAN_DETAILS: '/patient-mgmt/guardian/1.0/',
  PROVIDER_DETAILS: '/patient-mgmt/provider/1.0/',
  ADD_OR_UPDATE_OFFICE: '/patient-mgmt/provider/1.0/office',
  SEARCH_OFFICE: '/patient-mgmt/provider/1.0/office/search',
  PHARMACY_DETAILS: `${BASE_URL}/patient-mgmt/pharmacy/1.0/`,
  INSURANCE_DETAILS: `${BASE_URL}/patient-mgmt/payment/1.0/`,
  FILE_UPLOAD: `${BASE_URL}/patient-mgmt/file/1.0/`,
  PROFILE_IMAGE: `${BASE_URL}/patient-mgmt/patient/1.0/image`,
  GUARDIAN_IMAGE: `${BASE_URL}/patient-mgmt/guardian/1.0/image`,
  PROFILE_STATUS: `${BASE_URL}/patient-mgmt/profile/1.0`,

  // EHR sync service api endpoints
  GET_APPOINTMENTS_VIEW: `${BASE_URL}/ehr-sync-service/appointments/view`,
  GET_APPOINTMENT_PROFILES: `${BASE_URL}/ehr-sync-service/appointment/profile`,
  GET_APPOINTMENT_OFFICE_LOCATION_EXAM_ROOM: `${BASE_URL}/ehr-sync-service/appointment/offices`,
  SAVE_APPOINTMENT: `${BASE_URL}/ehr-sync-service/appointments`,
  DR_CHRONO_CHART_DETAILS: `${BASE_URL}/ehr-sync-service/ehrMapping`,
  GET_APPOINTMENT_PROVIDER_OFFICE_LOCATION: `${BASE_URL}/ehr-sync-service/appointment/office/list`,
  RELOAD_APPOINTMENT_CACHE: `${BASE_URL}/ehr-sync-service/appointment/reloadCache`,
  GET_APPOINTMENT_PROVIDERS: `${BASE_URL}/ehr-sync-service/appointment/provider/list`,
  GET_APPOINTMENT_PROFILES_BY_LOCATION: `${BASE_URL}/ehr-sync-service/appointment/profile/list`,
  GET_SELF_SCHEDULING_LOCATIONS: `${BASE_URL}/ehr-sync-service/self-scheduling/locations`,
  GET_SELF_SCHEDULING_PROVIDERS: `${BASE_URL}/ehr-sync-service/self-scheduling/providers`,
  GET_SELF_SCHEDULING_PROVIDER_AVAILABILITY: `${BASE_URL}/ehr-sync-service/self-scheduling/providers`,
  GET_SELF_SCHEDULING_PATIENT_CONTEXT: `${BASE_URL}/ehr-sync-service/self-scheduling/patients`,
  BOOK_SELF_SCHEDULING_APPOINTMENT: `${BASE_URL}/ehr-sync-service/self-scheduling/appointments`,
  /** MM-1191: staff / admin cancellation of a patient's appointment from the patient chart */
  STAFF_CANCEL_APPOINTMENT: `${BASE_URL}/ehr-sync-service/self-scheduling/admin/appointments`,
  /** MM-1168: office + provider pairs listed on the Sync Calendar page. */
  GET_CALENDAR_SYNC_PAIRS: `${BASE_URL}/ehr-sync-service/self-scheduling/admin/calendar-sync/pairs`,
  /** MM-1168: re-reads one pair's DrChrono calendar and rebuilds its self-scheduling free slots. */
  SYNC_CALENDAR: `${BASE_URL}/ehr-sync-service/self-scheduling/admin/calendar-sync`,

  // User management api endpoints
  GET_USER_DETAILS: `${BASE_URL}/user-mgmt/users/1.0/`,
  GET_REGISTRATION_DETAILS: `${BASE_URL}/users/1.0`,
  GET_APPOINTMENT_PROFILES_BY_USER_AND_LOCATIONS: `${BASE_URL}/user-mgmt/staff/1.0/vma`,
  GET_APPOINTMENT_PROFILES_BY_USER: `${BASE_URL}/user-mgmt/staff/1.0/profile`,
  GET_STAFF_LIST_BY_LOCATION_ID: `${BASE_URL}/user-mgmt/staff/1.0/location`,
  GET_PROVIDERS: `${BASE_URL}/user-mgmt/staff/1.0/vma/providers`,

  // Payment service api endpoints
  VALIDATE_PAYMENT_STATUS: `${BASE_URL}/payment-service/customer/validate-payment-method`,

  // Assessment service api endpoints
  MCAT_I_SCORE_DETAILS: `${BASE_URL}/assessment-service/mcatIScore`,
  SEND_ASSESSNEBT_REMINDER: `${BASE_URL}/assessment-service`,

  // MFSH api endpoints
  SAVE_MFSH_ANSWERS: `${BASE_URL}/assessment-service/mfsh/1.0`,
  GET_MFSH_STATUS: `${BASE_URL}/assessment-service/mfsh/1.0/status`,
  GET_MFSH_LINK: `${BASE_URL}/assessment-service/mfsh/1.0/jotform-url`,

  // Wellbeing api endpoints
  SAVE_WELLBEING_ANSWERS: `${BASE_URL}/assessment-service/wellbeing/1.0`,
  GET_WELLBEING_SCORE: `${BASE_URL}/assessment-service/wellbeing/1.0/score`,
  GET_WELLBEING_STATUS: `${BASE_URL}/assessment-service/wellbeing/1.0/status`,
  GET_WELLBEING_TRACKER: `${BASE_URL}/assessment-service/wellbeing/1.0/history`,

  // MCAT api endpoints
  SAVE_MCAT_ANSWERS: `${BASE_URL}/assessment-service/mcat/1.0`,
  GET_MCAT_STATUS: `${BASE_URL}/assessment-service/mcat/1.0/status`,
  GET_MCAT_SCORE: `${BASE_URL}/assessment-service/mcatIScore`,
  GET_MCAT_TRACKER: `${BASE_URL}/assessment-service/mcatIScore/history`,

  PATIENT_DETAILS_FOR_ADMIN: `${BASE_URL}/patient-mgmt/patient/1.0/admin`,
  /** MM-1106: permanent delete of a patient (Admin / Tech VMA only) */
  HARD_DELETE_PATIENT: `${BASE_URL}/patient-mgmt/patient/1.0/admin/hardDelete`,
  USER_PERMISSIONS: `${BASE_URL}/user-mgmt/users/1.0/currentUser`,
  PROVIDER_UPLOAD: `${BASE_URL}/patient-mgmt/provider/1.0/upload`,
  PATIENTS_BY_PROVIDER: `${BASE_URL}/patient-mgmt/provider/1.0/office/{officeId}/patients`,
  // Vitals api endpoints
  VITALS_DETAILS: `${BASE_URL}/patient-mgmt/vitals/1.0`,
  GET_CHARTID_CONVERSATION_STATUS: `${BASE_URL}/secure-messaging-service/conversation`,
  GET_CONVERSATION_STATUS: `${BASE_URL}/secure-messaging-service/conversation/status`,
  GET_CHARTID: `${BASE_URL}/ehr-sync-service/ehrMapping`,
  GET_VMA_NAMES: `${BASE_URL}/user-mgmt/staff/1.0/teams`,
  CREATE_TASK: `${BASE_URL}/secure-messaging-service/task/create`,
  /** Auto-create a task from a yml template (MM-1130: guardian Request Your Balance -> PENDING-BALANCE) */
  AUTO_CREATE_TASK: `${BASE_URL}/secure-messaging-service/task/auto-create`,
  GET_TASK_LIST: `${BASE_URL}/secure-messaging-service/task/assigned`,
  GET_PATIENT_TASK_LIST: `${BASE_URL}/secure-messaging-service/task/user`,
  SYNC_PROFILE: `${BASE_URL}/patient-mgmt/profile/1.0/trigger/sync`,
  ARCHIVE_JOB: `${BASE_URL}/patient-mgmt/profile/1.0/trigger/archive`,
  GET_CITY_STATE: `${BASE_URL}/patient-mgmt/address/1.0/zipcode`,
  GET_UNASSIGNED_CONVERSATION: `${BASE_URL}/secure-messaging-service/conversation/unassigned`,
  GET_ASSIGNED_CONVERSATION: `${BASE_URL}/secure-messaging-service/conversation/assigned`,
  GET_GROUP_DETAILS: `${BASE_URL}/secure-messaging-service/cometchat/user/groups`,
  ASSIGN_CONVERSATION_TO_SELF: `${BASE_URL}/secure-messaging-service/conversation/assign`,
  ASSIGN_CONVERSATION_TO_OTHER: `${BASE_URL}/secure-messaging-service/conversation/assign`,
  JOIN_CONVERSATION: `${BASE_URL}/secure-messaging-service/conversation/join`,
  GET_CONVERSATION_COUNT: `${BASE_URL}/secure-messaging-service/conversation/count`,
  GET_VMA_STATUS_COUNT: `${BASE_URL}/secure-messaging-service/cometchat/vma/status`,
  CHECK_IN_DETAILS: `${BASE_URL}/ehr-service/appointment/checkin`,
  VALIDATE_ZIP_CODE: `${BASE_URL}/auth/1.0/zipcode`,
  CREATE_PATIENT: `${BASE_URL}/ehr-service/appointment/createPatient`,
  GET_REPORT_TILES: `${BASE_URL}/assessment-service/mcat/1.0/provider/report`,
  GET_REPORT_DETAILS: `${BASE_URL}/assessment-service/mcat/1.0/provider/report`,
  SAVE_RATING: `${BASE_URL}/assessment-service/mcat/1.0/ratings`,
  SAVE_SUGGESTIONS: `${BASE_URL}/assessment-service/mcat/1.0/comments`,
  UPDATE_PIN: `${BASE_URL}/user-mgmt/users/1.0/pin/change`,
  CHECK_PIN: `${BASE_URL}/user-mgmt/users/1.0/pin/verify`,
  GET_STRIPE_LINK: `${BASE_URL}/payment-service/card/manage`,
  PAY_AMOUNT: `${BASE_URL}/ehr-service/payment/generate`,
  GET_TASK_COUNT: `${BASE_URL}/secure-messaging-service/task/count`,
  GET_SIBLING: `${BASE_URL}/patient-mgmt/patient/1.0/sibling`,
  GET_SIBLING_AUTOCOMPLETE: `${BASE_URL}/patient-mgmt/patient/1.0/sibling/autocomplete`,
  GET_SIBLING_ADMIN: `${BASE_URL}/patient-mgmt/patient/1.0/admin/sibling`,
  DOWNLOAD_MCAT_REPORT: `${BASE_URL}/assessment-service/mcat/1.0/patientreport`,
  GET_PATIENT_NAMES: `${BASE_URL}/secure-messaging-service/cometchat/user/guid`,
  GET_PAYMENT_HISTORY: `${BASE_URL}/payment-service/payment-transactions/patient`,
  CHARGE_PAYMENT: `${BASE_URL}/payment-service/payment-transactions`,
  PAYMENT_ACTION: `${BASE_URL}/payment-service/payment-transactions/action`,
  GET_GUARDIAN_DETAILS: `${BASE_URL}/patient-mgmt/guardian/1.0/accountTransfer`,
  SEND_REQUEST: `${BASE_URL}/patient-mgmt/tickets`,
  GET_ALL_REQUESTS: `${BASE_URL}/patient-mgmt/tickets`,
  GET_CONTACT_DETAILS: `${BASE_URL}/patient-mgmt/guardian/1.0/guardianContact`,
  UPDATE_PASSWORD: `${BASE_URL}/user-mgmt/users/1.0/resetProfilePassword`,
  SAVE_COLUMNS: `${BASE_URL}/user-mgmt/view/column-settings`,
  GET_ALL_USERS: `${BASE_URL}/user-mgmt/staff/1.0/vma`,
  SAVE_USER: `${BASE_URL}/user-mgmt/staff/1.0/vma/signup`,
  GET_USER_BY_TYPE: `${BASE_URL}/user-mgmt/staff/1.0/type`,
  CHECK_DUPLICATE_REQUEST: `${BASE_URL}/patient-mgmt/tickets/check/pending/job`,
  MDAC_PATIENTS_LIST: `${BASE_URL}/patient-mgmt/mdac/1.0/patients`,
  MDAC_PATIENTS_ONBOARDING: `${BASE_URL}/patient-mgmt/mdac/1.0/patients/onboarding`,
  GET_GRID_SETTINGS: `${BASE_URL}/user-mgmt/grid-settings`,
  SEARCH_CHART: `${BASE_URL}/patient-mgmt/mdac/1.0/charts/search`,
  SEARCH_PATIENTS: `${BASE_URL}/patient-mgmt/mdac/1.0/search`,
  MWISE_FEEDBACK: `${BASE_URL}/patient-mgmt/patient/1.0/mwise/feedback`,
  REFERRAL_SOURCE: `${BASE_URL}/user-mgmt/referral/1.0`,

  //User Role and Permission
  GET_ALL_ROLES: `${BASE_URL}/user-mgmt/roles/1.0`,
  CREATE_ROLE: `${BASE_URL}/user-mgmt/roles/1.0`,
  UPDATE_ROLE: `${BASE_URL}/user-mgmt/roles/1.0`,
  DEACTIVATE_ROLE: `${BASE_URL}/user-mgmt/roles/1.0/deactivate`,
  GET_ROLE_PERMISSIONS: `${BASE_URL}/user-mgmt/roles/1.0`,
  GET_ACTIVE_PERMISSIONS: `${BASE_URL}/user-mgmt/roles/1.0/permissions/active`,
  UPDATE_PERMISSION: `${BASE_URL}/user-mgmt/roles/1.0/permissions/update`,
  PING: `${BASE_URL}/user-mgmt/ping`,

  CHECK_DOCUMENT_STATUS: `${BASE_URL}/documentation-mgmt/consent/status`,
  ACKNOWLEDGE_CONSENT: `${BASE_URL}/documentation-mgmt/consent`,
  GET_APPOINTMENTS: `${BASE_URL}/patient-mgmt/patient/1.0/appointments`,
  PATIENT_CONTACT: `${BASE_URL}/patient-mgmt/patient/1.0/contact`,
  GET_GROUP_MEMBERS: `${BASE_URL}/secure-messaging-service/conversation/group-members`,
  UPLOAD_DOCUMENT: `${BASE_URL}/documentation-mgmt/document/upload`,
  UPLOAD_DOCUMENT_PDF: `${BASE_URL}/documentation-mgmt/api/documents/upload-pdf`,
  UPLOAD_DOCUMENT_IMAGES: `${BASE_URL}/documentation-mgmt/api/documents/upload-images`,
  PATIENT_UPLOADED_DOCUMENTS: `${BASE_URL}/documentation-mgmt/api/documents/patient`,
  UPLOAD_STAFF_DOCUMENT: `${BASE_URL}/documentation-mgmt/api/documents/upload-staff-file`,
  STAFF_UPLOADED_DOCUMENTS: `${BASE_URL}/documentation-mgmt/api/documents/staff`,
  GUARDIAN_UPLOADED_DOCUMENTS: `${BASE_URL}/documentation-mgmt/api/documents/guardian`,
  DOCUMENT_FILE_DOWNLOAD: `${BASE_URL}/documentation-mgmt/api/documents`,
  DOCUMENT_REVIEW_BASE: `${BASE_URL}/documentation-mgmt/api/admin/document-review`,
};
